module.exports = __webpack_public_path__ + "static/img/network disconnection@3x.5534a6d7.png";